import request from 'utils/request'
// import axios from 'axios'
export const getTableData = params =>
  request().get('credit-saas/grade/result/detail', {
    params,
  })

// 获取 token
// export const getToken = () => request().get('credit-saas/token')

//获取购买记录

// let prefix = '/saas'

// if (process.env.NODE_ENV !== 'development') {
//   prefix = 'https://le-credit.lenovo.com/saas/grade'
// }

// export const getTableData = (token, params) =>
//   axios.get(`${prefix}/result/detail`, {
//     headers: {
//       Authorization: 'Bearer:' + token,
//       company: 'Rain34W20210714133X'
//     },
//     params
//   })
